module.exports = __webpack_public_path__ + "img/amex.995d5a27.png";